import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { TOGGLE_VARIANTS } from "./constants";

// Absent -> false (e.g. `pressed`, `disabled`).
const booleanAttribute = z
  .string()
  .optional()
  .transform((value) => value !== undefined && value !== "false");

export const toggleDataSchema = z.object({
  size: z.enum(SIZES).optional(),
  variant: z.enum(TOGGLE_VARIANTS).optional(),
  label: z.string().optional(),
  icon: z
    .string()
    .optional()
    .describe("Optional Lucide icon name shown inside the toggle."),
  value: z.string().optional(),
  pressed: booleanAttribute,
  disabled: booleanAttribute,
});

export type ToggleDataProps = z.infer<typeof toggleDataSchema>;
